<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_cards'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2">
              <div class="row">
                <b-form-group class="col-md-3" label="Class">
                  <v-select
                    :options="schoolclasses.filter((c) => c.level == 2)"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    @input="FetchStudents"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Student">
                  <v-select
                    readonly="true"
                    :options="students"
                    placeholder="Select Student"
                    v-model="student"
                    :reduce="(students) => students.student.student_id"
                  >
                    <template slot="option" slot-scope="option">
                      <div>
                        {{ option.student.first_name }}
                        {{ option.student.last_name }} {{ option.class.name }}
                        {{ option.stream.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div>
                        {{ option.student.first_name }}
                        {{ option.student.last_name }} {{ option.class.name }}
                        {{ option.stream.name }}
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>
              </div>
            </div>

            <div
              v-if="
                exammarks && exammarks.student && exammarks.student.length > 0
              "
            >
              <div class="text-center">
                <router-link
                  :to="{
                    path: '/printsummarisedreport',
                    query: {
                      term: schoolterm.id,
                      termname: schoolterm.name,
                      year: year,
                      class: schoolclass.id,
                      classname: schoolclass.name,
                      student_id: student,
                    },
                  }"
                  type="button"
                  class="btn-sm btn btn-primary"
                >
                  <i class="mdi mdi-printer"></i> Print
                </router-link>
              </div>

              <div class="card">
                <div
                  class="card-body"
                  style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
                >
                  <div class="d-flex justify-content-start align-items-start">
                    <div class="d-flex justify-content-start">
                      <span v-if="userData.logo != 0"
                        ><img :src="getLogo(userData.logo)" height="80"/><br
                      /></span>
                      <span v-else
                        ><img src="@/assets/images/logo.png" height="80"/></span
                      ><br />
                    </div>

                    <div class="text-start  school-info">
                      <strong class="text-uppercase" style="font-size:22px">{{
                        userData.school
                      }}</strong
                      ><br />
                      <span style="font-size:17px" class="text-uppercase">
                        {{ userData.location }}</span
                      ><br />
                      <span style="font-size:17px"
                        >{{ userData.email }} | {{ userData.contact }}</span
                      ><br />
                      MOTTO :
                      <span style="font-size:15px" class="text-uppercase">
                        {{ userData.motto }}</span
                      >
                    </div>
                  </div>

                  <div class="lines"></div>
                  <br />
                  <div style="text-align: center;">
                    <span
                      style="color: black;font-size:24px;"
                      class="text-uppercase text-decoration-underline"
                    >
                      <b
                        >{{ schoolterm.name }} {{ exam.name }} REPORT -
                        {{ year }}</b
                      > </span
                    ><br /><br />
                  </div>

                  <div class="d-flex justify-content-between">
                    <div
                      class="text-start text-uppercase"
                      style="font-size:17px;"
                    >
                      NAME :
                      <strong
                        >{{ exammarks.student[0].first_name }}
                        {{ exammarks.student[0].last_name }}</strong
                      >
                      <br />
                      STUDENT ID :
                      <strong>{{ exammarks.student[0].student_id }}</strong>
                      <br />
                    </div>

                    <div
                      class="text-end text-uppercase"
                      style="font-size:17px;"
                    >
                      CLASS : <strong>{{ schoolclass.name }} </strong><br />
                      SCHOOL PAY CODE : {{ exammarks.student[0].school_pay_code
                      }}<br />
                    </div>

                    <div>
                      <img
                        :src="getFiles(exammarks.student[0].student_photo)"
                        height="80"
                      />
                    </div>
                  </div>

                  <!-- Detailed  report -->
                  <div class="row mt-3">
                    <div class="col-md-12 mx-auto">
                      <table class="table table-sm">
                        <tr class="text-uppercase">
                          <th>Subject</th>
                          <th>Competency</th>
                          <th>Score</th>
                          <th>Out of 20</th>
                          <th>General Remarks</th>
                          <th>Subject Teacher</th>
                        </tr>
                        <tr v-for="x in marks[0].exam_subjects" :key="x.id">
                          <td>{{ x.exam.name }}</td>
                          <td>
                            <div
                              class="mb-3"
                              v-for="y in x.marksdetails"
                              :key="y.id"
                            >
                              {{ y.id }} {{ y.competencies[0].competency }}
                              <br />
                              {{ y.competencies[0].description }}
                            </div>
                          </td>
                          <td>
                            <div
                              class="mb-5"
                              v-for="y in x.marksdetails"
                              :key="y.id"
                            >
                              {{ y.mark[0].mark }}
                            </div>
                          </td>
                          <td>
                            <b>{{ calculateOutOf20(x.marksdetails) }} </b>
                          </td>
                          <td>
                            <div
                              class="mb-5"
                              v-for="y in x.marksdetails"
                              :key="y.id"
                            >
                              {{ y.mark[0].remark }}
                            </div>
                          </td>
                          <td>
                            <div
                              class="mb-5"
                              v-for="y in x.marksdetails"
                              :key="y.id"
                            >
                              {{ y.teacher.full_name }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!-- Summarised report -->
                  <div class="row mt-3">
                    <div class="col-md-12 mx-auto">
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr class="text-uppercase bg-light">
                            <th rowspan="2">SUBJECTS</th>
                            <th
                              v-if="hasBOTMarks(exammarks)"
                              rowspan="2"
                              v-html="getBOTHeaderText()"
                            ></th>
                            <th
                              :colspan="
                                Math.max(0, getMaxCompetencies(exammarks))
                              "
                              class="text-center"
                            >
                              FORMATIVE ASSESSMENT
                            </th>
                            <th rowspan="2">AVE</th>
                            <th rowspan="2">TOTAL<br />(OUT OF 20)</th>
                            <th rowspan="2" v-html="getEOTHeaderText()"></th>
                            <th rowspan="2">FINAL MARK<br />(100%)</th>
                            <th rowspan="2">GRADE</th>
                            <th rowspan="2">INITIALS</th>
                          </tr>
                          <tr class="text-uppercase bg-light">
                            <th
                              v-for="n in Math.max(
                                0,
                                getMaxCompetencies(exammarks),
                              )"
                              :key="n"
                            >
                              A{{ n }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="subject in exammarks.subjects"
                            :key="subject.subject.id"
                          >
                            <td class="text-uppercase font-weight-bold">
                              {{ subject.subject.name }}
                            </td>
                            <td v-if="hasBOTMarks(exammarks)">
                              {{ getBOTMark(subject) }}
                            </td>
                            <td
                              v-for="n in Math.max(
                                0,
                                getMaxCompetencies(exammarks),
                              )"
                              :key="n"
                            >
                              {{ getCompetencyMark(subject, n) }}
                            </td>
                            <td class="font-weight-bold">
                              {{ calculateCompetencyAverage(subject) }}
                            </td>
                            <td class="font-weight-bold">
                              {{ calculateTotalOutOf20(subject) }}
                            </td>
                            <td class="font-weight-bold">
                              {{ getEOTMark(subject) }}
                            </td>
                            <td class="font-weight-bold">
                              {{ calculateFinalMark(subject) }}
                            </td>
                            <td class="font-weight-bold">
                              {{ calculateGrade(calculateFinalMark(subject)) }}
                            </td>
                            <td>{{ getTeacherInitials(subject) }}</td>
                          </tr>

                          <tr class="text-uppercase font-weight-bold bg-light">
                            <td :colspan="hasBOTMarks(exammarks) ? 1 : 1">
                              <strong>TOTAL</strong>
                            </td>
                            <td v-if="hasBOTMarks(exammarks)">
                              {{ calculateBOTTotal(exammarks) }}
                            </td>
                            <td colspan="5"></td>
                            <td>{{ calculateTotal20Total(exammarks) }}</td>
                            <td>{{ calculateEOTTotal(exammarks) }}</td>
                            <td>{{ calculateFinalTotal(exammarks) }}</td>
                          </tr>

                          <tr class="text-uppercase font-weight-bold bg-light">
                            <td :colspan="hasBOTMarks(exammarks) ? 1 : 1">
                              <strong>AVERAGE</strong>
                            </td>
                            <td v-if="hasBOTMarks(exammarks)">
                              {{ calculateBOTAverage(exammarks) }}
                            </td>
                            <td colspan="5"></td>
                            <td>{{ calculateTotal20Average(exammarks) }}</td>
                            <td>{{ calculateEOTAverage(exammarks) }}</td>
                            <td>{{ calculateFinalAverage(exammarks) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between mt-3 mb-4">
                    <div>
                      <h5>Grading scheme:</h5>
                      <table>
                        <tr>
                          <td>85+</td>
                          <td>80 - 84</td>
                          <td>75 - 79</td>
                          <td>70 - 74</td>
                          <td>65 - 69</td>
                          <td>50 - 64</td>
                          <td>40 - 49</td>
                          <td>0 - 39</td>
                        </tr>
                        <tr>
                          <td>A+</td>
                          <td>A</td>
                          <td>B</td>
                          <td>C</td>
                          <td>D</td>
                          <td>E</td>
                          <td>F</td>
                          <td>G</td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <h5>Identifier Ranges:</h5>
                      <table>
                        <tr>
                          <td>16.0 - 20.0</td>
                          <td>10.6 - 15.9</td>
                          <td>6.6 - 9.9</td>
                        </tr>
                        <tr>
                          <td>Level 3</td>
                          <td>Level 2</td>
                          <td>Level 1</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-12 mx-auto">
                    <div>
                      <h5>Grading Scale</h5>
                      <table class="table table-sm">
                        <tr>
                          <th>Identifier</th>
                          <th>Score Range</th>
                          <th>Descriptor</th>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>2.50 - 3.00</td>
                          <td>
                            <b>Outstanding:</b> Most or all LO's achieved for
                            overall achievement
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>1.50 - 2.49</td>
                          <td>
                            <b>Moderate:</b> Many LO's achieved, enough for
                            overall achievement
                          </td>
                        </tr>
                        <tr>
                          <td>1</td>
                          <td>0.90 - 1.49</td>
                          <td>
                            <b>Basic:</b> Few LO's achieved, but not sufficient
                            for overall achievement
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between mt-2">
                    <div>
                      <h5 class="text-uppercase">
                        <strong>Class Teacher</strong>
                      </h5>
                      <br />
                      <span
                        >Comment:
                        <span class="text-uppercase"
                          ><strong>{{
                            getComment(
                              calculateOverallGrade(exammarks),
                              comment_groups,
                              1,
                            )
                          }}</strong></span
                        ></span
                      ><br />
                      <span class="signature-line">
                        Signature :
                        <span v-if="getSignatureForStatus(comment_groups, 1)">
                          <img
                            :src="getSignatureForStatus(comment_groups, 1)"
                            height="30"
                            alt="Class Teacher Signature"
                          />
                        </span>
                        <span v-else
                          >................................................</span
                        >
                      </span>
                    </div>
                    <div>
                      <h5 class="text-uppercase">
                        <strong>Head Teacher</strong>
                      </h5>
                      <br />
                      <span
                        >Comment:
                        <span class="text-uppercase"
                          ><strong>{{
                            getComment(
                              calculateOverallGrade(exammarks),
                              comment_groups,
                              2,
                            )
                          }}</strong></span
                        ></span
                      ><br />
                      <span class="signature-line">
                        Signature :
                        <span v-if="getSignatureForStatus(comment_groups, 2)">
                          <img
                            :src="getSignatureForStatus(comment_groups, 2)"
                            height="30"
                            alt="Head Teacher Signature"
                          />
                        </span>
                        <span v-else
                          >..................................................</span
                        >
                      </span>
                    </div>
                  </div>
                </div>

                <br /><br />
                <div class="d-flex justify-content-between">
                  <span
                    >Next Term Begins on :
                    <strong class="text-uppercase">{{
                      date(userData.next_term)
                    }}</strong></span
                  >
                  <span
                    >Date of Issue: <strong>{{ currentDate }}</strong></span
                  >
                </div>
                <br /><br />
                <center>
                  <qr-code
                    :text="exammarks.student[0].student_id"
                    :size="100"
                    error-level="L"
                  ></qr-code>
                </center>

                <div class="watermark">
                  <span v-if="userData.logo != 0"
                    ><img :src="getLogo(userData.logo)" height="250"/><br
                  /></span>
                  <span v-else
                    ><img src="@/assets/images/logo.png" height="250"/></span
                  ><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Dynamic Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Formative Report Cards",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Formative Report Cards", active: true },
      ],
      id: "",
      schoolsubjects: [],
      exam_subjects: [],
      schoolsubject: "",
      stream: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      students: [],
      year: new Date().getFullYear(),
      marks: [],
      exammarks: { subjects: [] },
      filterby: "1",
      student: "",
      student_id: "",
      currentDate: this.formatDate(new Date()),
      comment_groups: [],
      isLoading: false,
    };
  },
  computed: {
    ...schooltermComputed,
    ...schoolclassComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.isBusy = false;
  },
  methods: {
    ...schooltermMethods,
    ...schoolclassMethods,

    calculateOutOf20(marksdetails) {
      if (!marksdetails || !marksdetails.length) return 0;
      let totalMarks = marksdetails.reduce(
        (sum, y) => sum + (y.mark[0]?.mark || 0),
        0,
      );
      let average = totalMarks / marksdetails.length;
      return Math.round((average / 3) * 20);
    },

    calculateCompetencyAverage(subject) {
      if (!subject.competencies?.length) return "0.0";

      const marks = [];
      subject.competencies.forEach((competency) => {
        if (competency.marks && competency.marks.length > 0) {
          const mark = competency.marks[0].mark;
          if (!isNaN(mark) && mark !== null && mark !== undefined) {
            marks.push(parseFloat(mark));
          }
        }
      });

      if (marks.length === 0) return "0.0";

      const sum = marks.reduce((total, mark) => total + mark, 0);
      const average = sum / marks.length;

      return Math.round(average);
    },

    calculateTotalOutOf20(subject) {
      const avg = parseFloat(this.calculateCompetencyAverage(subject)) || 0;
      return Math.round((avg / 3) * 20);
    },

    calculateFinalMark(subject) {
      const botMark = this.getBOTMark(subject) * 0.4;
      const formativeAvg = this.calculateCompetencyAverage(subject);
      const totalOutOf20 = (formativeAvg / 3) * 20;
      const eotMark = this.getEOTMark(subject) * 0.4;
      return Math.round(botMark + totalOutOf20 + eotMark);
    },

    hasBOTMarks(data) {
      return data?.subjects?.some((s) => s.botmarks?.[0]?.mark);
    },

    getMaxCompetencies(data) {
      if (!data?.subjects?.length) return 0;
      const lengths = data.subjects.map((s) => s.competencies?.length || 0);
      return Math.max(...lengths, 0);
    },

    getBOTMark(subject) {
      return subject?.botmarks?.[0]?.mark || 0;
    },

    getCompetencyMark(subject, position) {
      if (!subject?.competencies || !Array.isArray(subject.competencies))
        return 0;
      const competency = subject.competencies[position - 1];
      return competency?.marks?.[0]?.mark || 0;
    },

    getEOTMark(subject) {
      return subject?.eotmarks?.[0]?.mark || 0;
    },

    calculateColumnTotal(data, position) {
      return (
        data?.subjects?.reduce(
          (t, s) => t + this.getCompetencyMark(s, position),
          0,
        ) || 0
      );
    },

    calculateCompetencyAverageTotal(data) {
      const total =
        data?.subjects?.reduce(
          (t, s) => t + parseFloat(this.calculateCompetencyAverage(s)),
          0,
        ) || 0;
      return Math.round(total);
    },

    calculateTotal20Total(data) {
      const total =
        data?.subjects?.reduce(
          (t, s) => t + parseFloat(this.calculateTotalOutOf20(s)),
          0,
        ) || 0;
      return Math.round(total);
    },

    calculateEOTTotal(data) {
      return data?.subjects?.reduce((t, s) => t + this.getEOTMark(s), 0) || 0;
    },

    calculateFinalTotal(data) {
      return (
        data?.subjects?.reduce((t, s) => t + this.calculateFinalMark(s), 0) || 0
      );
    },

    calculateBOTTotal(data) {
      return data?.subjects?.reduce((t, s) => t + this.getBOTMark(s), 0) || 0;
    },

    calculateCompetencyColumnAverage(data, position) {
      const subjectCount = data?.subjects?.length || 1;
      const total = this.calculateColumnTotal(data, position);
      return Math.round(total / subjectCount);
    },

    calculateCompetencyOverallAverage(data) {
      const subjectCount = data?.subjects?.length || 1;
      const total = parseFloat(this.calculateCompetencyAverageTotal(data));
      return Math.round(total / subjectCount);
    },

    calculateTotal20Average(data) {
      const subjectCount = data?.subjects?.length || 1;
      const total = parseFloat(this.calculateTotal20Total(data));
      return Math.round(total / subjectCount);
    },

    calculateEOTAverage(data) {
      const subjectCount = data?.subjects?.length || 1;
      const total = this.calculateEOTTotal(data);
      return Math.round(total / subjectCount);
    },

    calculateFinalAverage(data) {
      const subjectCount = data?.subjects?.length || 1;
      const total = this.calculateFinalTotal(data);
      return Math.round(total / subjectCount);
    },

    calculateBOTAverage(data) {
      if (!this.hasBOTMarks(data)) return "0.0";

      const botMarks = [];
      data.subjects.forEach((subject) => {
        const botMark = this.getBOTMark(subject);
        if (botMark > 0) {
          botMarks.push(botMark);
        }
      });

      if (botMarks.length === 0) return "0.0";

      const sum = botMarks.reduce((total, mark) => total + mark, 0);
      return Math.round(sum / botMarks.length);
    },

    calculateOverallGrade(data) {
      return this.calculateGrade(this.calculateFinalAverage(data));
    },

    calculateGrade(mark) {
      const num = typeof mark === "string" ? parseFloat(mark) : mark;
      if (num >= 85) return "A+";
      if (num >= 80) return "A";
      if (num >= 75) return "B";
      if (num >= 70) return "C";
      if (num >= 65) return "D";
      if (num >= 50) return "E";
      if (num >= 40) return "F";
      return "G";
    },

    getBOTHeaderText() {
      return this.hasBOTMarks(this.exammarks) ? "BOT<br>(out of 40%)" : "";
    },

    getEOTHeaderText() {
      return this.hasBOTMarks(this.exammarks)
        ? "EOT<br>(out of 40%)"
        : "EOT<br>(out of 80%)";
    },

    getTeacherInitials(subject) {
      return (
        subject?.teacher?.[0]
          ?.split(" ")
          .map((n) => n[0])
          .join(".") || ""
      );
    },

    getLogo(name) {
      return name ? `${axios.defaults.baseURL.slice(0, -3)}logos/${name}` : "";
    },

    getFiles(name) {
      return name
        ? `${axios.defaults.baseURL.slice(0, -3)}students/${name}`
        : "";
    },

    async FetchStudents() {
      try {
        const url = `/findstudents/${this.schoolclass.id},${this.schoolterm.id},${this.year}`;
        const response = await axios.get(url);
        this.students = response.data.students || [];
      } catch (error) {
        this.students = [];
      }
    },

    async FilterData() {
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append("term", this.schoolterm.id);
        formData.append("year", this.year);
        formData.append("class", this.schoolclass.id);
        formData.append("student_id", this.student);

        const [report, marks, comments] = await Promise.all([
          axios.post("/reportmarks", formData),
          axios.post(
            `/viewexammarks/${this.student},${this.schoolclass.id},${this.schoolterm.id},${this.year}`,
          ),
          axios.get(`/comment-group/${this.schoolclass.id}`),
        ]);

        this.exammarks = report.data.reportmarks || { subjects: [] };
        this.marks = marks.data.marks || {};
        this.comment_groups = comments.data.comment_groups || [];
      } catch (error) {
        //console.error("FilterData error:", error);
        this.exammarks = { subjects: [] };
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(date) {
      return date?.toLocaleDateString("en-GB") || "";
    },

    date(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date)) return "";

      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const suffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };

      return `${suffix(day)} ${month} ${year}`;
    },

    getComment(aggregate, comment_groups, status) {
      const normalizedGrade = aggregate.replace("+", "");
      for (let group of comment_groups) {
        if (group.status == status && normalizedGrade === group.start_agg) {
          return group.comment;
        }
      }
      return " ............................................................................................... ";
    },

    getSignatureForStatus(comment_groups, status) {
      if (
        !comment_groups ||
        !Array.isArray(comment_groups) ||
        comment_groups.length === 0
      ) {
        return null;
      }
      const group = comment_groups.find(
        (group) => group.status === status && group.signature,
      );

      if (group && group.signature) {
        let url = axios.defaults.baseURL;
        let imagelink = url.slice(0, -3) + "signatures/" + group.signature;
        return imagelink;
      }
      return null;
    },
  },
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}

.signature-line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.font-weight-bold {
  font-weight: bold;
}

.text-uppercase {
  text-transform: uppercase;
}

.bg-light {
  background-color: #f8f9fa;
}

.card {
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-evenly {
  justify-content: space-evenly;
}

.mt-3 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.lines {
  border-bottom: 4px solid black;
  position: relative;
  margin-top: 10px;
}

.lines::after {
  content: "";
  display: block;
  border-bottom: 3px solid orangered;
  margin-top: 2px;
}
.school-info {
  margin-left: 15px;
  line-height: 1.3;
}
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.15;
  pointer-events: none;
  z-index: 1000;
}

.watermark img {
  max-width: 100%;
}
</style>
